/**
 * The board's palette and metrics, written once.
 *
 * These are the design's own values rather than the `--v2-*` tokens. The token
 * set carries no amber or blue of the right hue and a warmer grey than this
 * design uses, so mapping onto it approximates — and an approximation is what
 * "does not match the design" means. Holding them here instead of inline keeps
 * the table, the panel, the menus and the chat cards from drifting apart.
 *
 * They are whole Tailwind class strings rather than raw hex because Tailwind
 * reads source files as text: a literal like `bg-[#FBFBFB]` is found here, a
 * class assembled at runtime from a hex constant is not.
 */

/** Hairlines. `LINE` frames a surface; `LINE_SOFT` divides within one. */
export const LINE = 'border-[rgba(0,0,0,0.08)]';

export const LINE_SOFT = 'border-[rgba(0,0,0,0.06)]';

/** Text, from body ink down to a placeholder. */
export const INK = 'text-[#181818]';

export const INK_2 = 'text-[#696969]';

export const INK_3 = 'text-[#9A9A9A]';

/** The page's white surface. */
export const CARD = 'bg-white';

/** A section heading inside the panel. */
export const SECTION_LABEL =
  'text-[11px] uppercase tracking-[0.07em] font-medium text-[#9A9A9A]';

/**
 * A label, as a chip, in the panel and the menus. The board's rows draw labels
 * with the list table's own dotted chip (`ListTableLabels`).
 */
export const LABEL_CHIP =
  'inline-block max-w-full truncate rounded-[6px] border border-[rgba(0,0,0,0.06)] bg-[#FBFBFB] px-[9px] py-[3px] text-[12.5px] text-[#181818]';

/** A value the task does not hold, in the panel. */
export const EMPTY_VALUE = 'text-[#B7B4AC]';
